import { render, staticRenderFns } from "./LampView.vue?vue&type=template&id=67d32a22&"
import script from "./LampView.vue?vue&type=script&lang=js&"
export * from "./LampView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports